module.exports = __webpack_public_path__ + "static/media/condominio_sigin.7f330a14.jpg";